import lodashCloneDeep from 'lodash/cloneDeep';
import moment from 'moment-timezone';

import {
    AUTOMATION_STATUS_CHANGED,
    AUTOMATION_ACTION_SELECTED,
    AUTOMATION_ADDITIONAL_FIELDS_CHANGED,
    AUTOMATION_INITIALISE,
    AUTOMATION_SCHEDULE_CHANGED,
    RESET_AUTOMATION_DATA,
    AUTOMATION_INITIALISE_ALL,
    AUTOMATION_ADD_SCHEDULE,
    AUTOMATION_REMOVE_SCHEDULE,
    AUTOMATION_UPDATE_SCHEDULE_FIELD,
} from '../reduxActions/actionNameEnums';
import { frequencyTypes, intervals } from 'src/constants';

const getDefaultScheduleItem = () => ({
    frequency: frequencyTypes.DAY,
    frequencyData: {},
    selectedInterval: intervals.DAILY,
    repeat: 1,
    startTimestamp: moment().add(1, 'day').add(1, 'hour'),
    isEnabled: false,
    fromToRange: {},
    automation: {},
    customInterval: null,
});

const normaliseScheduleItem = (item) => {
    return {
        ...(item._id ? { _id: item._id } : {}),
        frequency: item.frequency || frequencyTypes.DAY,
        frequencyData: item.frequencyData || {},
        selectedInterval: item.selectedInterval || intervals.DAILY,
        repeat: item.repeat || 1,
        startTimestamp: item.startTimestamp ? moment(item.startTimestamp) : moment().add(1, 'day').add(1, 'hour'),
        isEnabled: item.isEnabled || false,
        fromToRange: item.fromToRange || {},
        automation: item.automation || {},
        customInterval: item.customInterval || null,
    };
};

const initialState = {
    schedules: [],
};

const automationReducer = (state = initialState, action) => {
    const { type, payload } = action;
    const clonedState = lodashCloneDeep(state);

    switch (type) {
        case AUTOMATION_INITIALISE_ALL: {
            const schedules = (payload || []).map(normaliseScheduleItem);
            return { ...clonedState, schedules };
        }

        case AUTOMATION_ADD_SCHEDULE: {
            clonedState.schedules.push(getDefaultScheduleItem());
            return clonedState;
        }

        case AUTOMATION_REMOVE_SCHEDULE: {
            clonedState.schedules.splice(payload, 1);
            return clonedState;
        }

        case AUTOMATION_UPDATE_SCHEDULE_FIELD: {
            const { index, updates } = payload;
            if (clonedState.schedules[index]) {
                clonedState.schedules[index] = {
                    ...clonedState.schedules[index],
                    ...updates,
                };
            }
            return clonedState;
        }

        // Legacy single-schedule actions (kept for backward compatibility)
        case AUTOMATION_STATUS_CHANGED: {
            if (clonedState.schedules[0]) {
                clonedState.schedules[0].isEnabled = payload;
            }
            return clonedState;
        }

        case AUTOMATION_ACTION_SELECTED: {
            if (clonedState.schedules[0]) {
                clonedState.schedules[0].automation = {
                    ...clonedState.schedules[0].automation,
                    action: payload,
                };
            }
            return clonedState;
        }

        case AUTOMATION_ADDITIONAL_FIELDS_CHANGED: {
            if (clonedState.schedules[0]) {
                clonedState.schedules[0].automation = {
                    ...clonedState.schedules[0].automation,
                    additionalFields: payload,
                };
            }
            return clonedState;
        }

        case AUTOMATION_INITIALISE: {
            const normalised = normaliseScheduleItem(payload);
            if (Object.keys(payload).length === 0) {
                return { ...clonedState, schedules: [] };
            }
            return { ...clonedState, schedules: [normalised] };
        }

        case AUTOMATION_SCHEDULE_CHANGED: {
            if (clonedState.schedules[0]) {
                clonedState.schedules[0] = {
                    ...clonedState.schedules[0],
                    ...payload,
                };
            }
            return clonedState;
        }

        case RESET_AUTOMATION_DATA:
            return { schedules: [] };

        default:
            return clonedState;
    }
};

export default automationReducer;
